__turbopack_context__.v({
  "borderRadius": "AboutUsSiteInnerContainer-module__3WFovW__borderRadius",
  "innerBackground__white": "AboutUsSiteInnerContainer-module__3WFovW__innerBackground__white",
  "innerContainer": "AboutUsSiteInnerContainer-module__3WFovW__innerContainer",
  "overflowHidden": "AboutUsSiteInnerContainer-module__3WFovW__overflowHidden",
  "positionRelative": "AboutUsSiteInnerContainer-module__3WFovW__positionRelative",
  "withPadding": "AboutUsSiteInnerContainer-module__3WFovW__withPadding",
});
